var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    [
      _c(
        "b-nav",
        { attrs: { vertical: "" } },
        [
          _c("b-nav-text", { staticClass: "text-uppercase text-muted" }, [
            _vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/dashboard" } }, [
            _c("i", { staticClass: "ti-dashboard mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.adminSidebar.navItem.dashboard")))
            ])
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/admin/users" } }, [
            _c("i", { staticClass: "ti-user mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.adminSidebar.navItem.users")))
            ])
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/admin/contractpartners" } }, [
            _c("i", { staticClass: "ti-agenda mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("message.adminSidebar.navItem.contractPartners"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/account" } }, [
            _c("i", { staticClass: "ti-settings mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.adminSidebar.navItem.account")))
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38714b7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38714b7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminSidebar.vue
// module id = kgbA
// module chunks = 1